var map = {
	"./alcohol.png": 7304,
	"./arrow-left.png": 2236,
	"./arrow-right.png": 7996,
	"./bas-colon.png": 2940,
	"./bowel-cancer-UK.png": 493,
	"./btn-arrow-blue-down.png": 1532,
	"./btn-arrow-blue-up.png": 5212,
	"./btn-start-diving.png": 6820,
	"./bulle-left.png": 1136,
	"./bulle-right.png": 3716,
	"./chapter.png": 8415,
	"./colon-expo.png": 8296,
	"./colon.png": 2208,
	"./colonoscopy.png": 8024,
	"./corps-colon.png": 7188,
	"./corps-humain.png": 3444,
	"./digestive-cancers-europe.png": 4536,
	"./digestive-cancers-europe2.png": 1656,
	"./european-code-against-cancer.png": 9276,
	"./externe.png": 1176,
	"./facebook.png": 4524,
	"./family-history.png": 564,
	"./fin-colon-fond.png": 5860,
	"./fin-colon.png": 7288,
	"./fish.png": 9588,
	"./fobt.png": 5012,
	"./fond.png": 2584,
	"./guide-patients.png": 1076,
	"./instagram.png": 4676,
	"./journal.png": 100,
	"./knowing-your-biomarker.png": 4364,
	"./linkedin.png": 4324,
	"./logo.png": 1788,
	"./loupe.png": 5628,
	"./machine.png": 4079,
	"./masque.png": 1140,
	"./meats.png": 3492,
	"./microscope.png": 4420,
	"./milk.png": 536,
	"./nutrition-cancers.png": 4612,
	"./over-50.png": 9440,
	"./pecheur.png": 1516,
	"./pierre-fabre.png": 1820,
	"./plongeur-end.png": 264,
	"./plongeur-full.png": 7824,
	"./plongeur.png": 6260,
	"./polyps-cut.png": 1696,
	"./polyps-large.png": 4528,
	"./polyps-little.png": 3480,
	"./polyps-medium.png": 6311,
	"./polyps.png": 4047,
	"./polyps2.png": 6388,
	"./polyps3.png": 2516,
	"./relax.png": 5508,
	"./run.png": 8596,
	"./smoke.png": 3152,
	"./super-colon.png": 8264,
	"./symptoms.png": 2736,
	"./tete-colon-fond.png": 5608,
	"./tete-colon.png": 2628,
	"./twitter.png": 1972,
	"./vegetables.png": 9092,
	"./video1.png": 4120,
	"./video2.png": 4616,
	"./video3.png": 8484,
	"./video4.png": 3812,
	"./video5.png": 9148,
	"./video6.png": 1956,
	"./wcrf-2018.png": 1224,
	"./wonderful-colon-titre-fr.png": 864,
	"./wonderful-colon-titre.png": 7936,
	"./wonderful-colon-titre_2024.png": 9752,
	"./youtube.png": 2637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;